export const staging = {
  site: {
    baseName: 'conveyancer'
  },
  stripe: {
    key: 'pk_test_XjwossyzeR1943y1OYY3hER1'
  },
  api: {
    url: '/api/v1/user',
    baseUrl: 'https://searchlight-staging.com'
  }
};

export default staging;
